module.exports = __webpack_public_path__ + "static/media/iphone.81f09f26.svg";